import { Link } from 'react-router';
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var LoadingButton = require("components/utility/LoadingButton");

var CurrentUser = require('lib/account/CurrentUser');

require('users/parents/parent_page.scss');
require("users/students/student_progress_display.scss");

@connect(
	(state, props) => ({
		students: RosterSelectors.students({ state }),
		parents: RosterSelectors.parents({ state }),
		studentLists: RosterSelectors.studentLists({ state })
	}),
	(dispatch, props) => {
		function createParents(studentIDs, parentEmails) {
			// Do 5 at a time
			var BATCH_SIZE = 5;

			var theseStudentIDs = studentIDs.splice(0, BATCH_SIZE);
			var theseParentEmails = parentEmails.splice(0, BATCH_SIZE);

			return dispatch(RosterActions.createParents({
				studentIDs: theseStudentIDs,
				parentEmails: theseParentEmails,
				query: { no_background: true }
			})).then(() => {
				if (studentIDs.length) {
					return createParents(studentIDs, parentEmails);
				} else {
					return Promise.resolve();
				}
			})
		}

		function updateParents(parentIDs, parentEmails) {
			return dispatch(RosterActions.updateParent({
				id: parentIDs.pop(),
				update: { email: parentEmails.pop() },
			})).then(() => {
				if (parentIDs.length) {
					return updateParents(parentIDs, parentEmails);
				} else {
					return Promise.resolve();
				}
			})

		}
		return {
			populateData: () => {
				return dispatch(RosterActions.fetchStudents({
					embeds: ["student.parent", "parent.email"]
				}))
			},

			createParents,
			updateParents
		}
	}
)
@providePopulateData({ waitForLoad: true })
class StudentParentsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var parentEmails = {};
		props.students.forEach((student) => {
			var parent = this.getParent(student, props);
			if (parent) {
				parentEmails[student.id] = parent.email;
			} else {
				parentEmails[student.id] = "";
			}
		})

		this.state = { parentEmails, errors: {}, loading: false };
	}

	getParent(student, props) {
		props = props || this.props
		return props.parents.find(x => x.id === student.parent);
	}

	getStudentListName(student) {
		var studentList = this.props.studentLists.find(x => x.id === student.student_list_ids.primary);
		return studentList ? studentList.name : "-";
	}

	setParentEmail(student, e) {
		var parentEmails = { ...this.state.parentEmails, [student.id]: e.target.value };
		var errors = { ...this.state.errors };
		delete errors[student.id];
		this.setState({
			parentEmails, errors
		});
	}

	validateParentEmail(student) {
		var email = this.state.parentEmails[student.id];
		if (email && email.trim().length) {
			if (!EMAIL_REGEX.test(email)) {
				this.setState({
				 	errors: { ...this.state.errors, [student.id]: "This email is invalid" }
				})
			}
		}
	}

	submitParentEmails(e) {
		$wr.nope(e)

		if (_.keys(this.state.errors).length) {
			return;
		}

		var addedStudentIDs = [];
		var addedParentEmails = [];
		var updatedParentIDs = [];
		var updatedParentEmails = [];

		this.props.students.map((student) => {
			var parent = this.getParent(student);
			
			var newParentEmail = (this.state.parentEmails[student.id] || "").trim();
			if (newParentEmail.length) {
				if (!EMAIL_REGEX.test(newParentEmail)) {
					// Shouldn't have been able to submit, but filter it anyway
				} else if (!parent) {
					addedStudentIDs.push(student.id);
					addedParentEmails.push(newParentEmail);

				} else if (parent.email !== newParentEmail) {
					updatedParentIDs.push(parent.id);
					updatedParentEmails.push(newParentEmail);
				}
			}
		});

		var totalParentEmails = addedParentEmails.length + updatedParentEmails.length;
		if (totalParentEmails > 0) {
			var addressWord = $wr.pluralize("Address", totalParentEmails, "Addresses");
			var title = "Email " + addressWord + " Added!";

			if (totalParentEmails == 1) {
				var emailText = " The email has been ";
			} else {
				var emailText = " The emails have been ";
			}

			var text = "You have updated " + totalParentEmails + " parent email " +
				addressWord.toLowerCase() + "!" + emailText + "scheduled and will send shortly.";


			console.log("Adding: ", addedParentEmails.length)
			var promises = [];
			if (addedParentEmails.length > 0) {
				promises.push(
					this.props.createParents(addedStudentIDs, addedParentEmails)
				);
			}

			if (updatedParentEmails.length > 0) {
				promises.push(
					this.props.updateParents(updatedParentIDs, updatedParentEmails)
				);
			}

			this.setState({ loading: true });

			Promise.all(promises).then(() => {
				this.props.populateData().then(() => {
					this.setState({ loading: false });
				})
			})

			window.wrNotifications.triggerDropDownNotification({
				title: title, text: text, icon: "ok-circle"
			});

		} else {
			// "Fake" saving
			this.setState({ loading: true });
			setTimeout(() => { this.setState({ loading: false }) }, 2000);
		}
	}

	render() {
		var students = _.sortBy(this.props.students, (s) => {
			var base = this.getStudentListName(s);
			if (s.last_name == $wr.Constants.FILLER_LAST_NAME) {
				return base + " - " + s.first_name;
			} else {
				return base + " - " + s.last_name + ", " + s.first_name;
			}
		})
		var studentRows = students.map((student) => {

			if (student.parent != null) {
				var currentParentEmail = student.parent.email;
			} else {
				var placeholderValue = "Enter parent email";
			}
			if (this.state.errors[student.id]) {
				var error = (
					<div className="errorRed smallText">
						{ this.state.errors[student.id] }
					</div>
				)
			}
			return (
				<tr key={ student.id }>
					<td>{ this.getStudentListName(student) }</td>
					<td className="studentName">{ student.display_name }</td>
					<td>
						<input className="form-control" placeholder={ placeholderValue }
							type="email" 
							value={ this.state.parentEmails[student.id] }
							onChange={ this.setParentEmail.bind(this, student) }
							onBlur={ this.validateParentEmail.bind(this, student) } />
						{ error }
					</td>
				</tr>	
			)
		})

		if (_.keys(this.state.errors).length) {
			var buttonDisabled = true;
			var overallError = (
				<div className="errorRed smallText text-center">
					Fix errors with emails above before saving
				</div>
			);
		}

		return (
			<div className="container studentParentsPage">
				<header className="pageHeader">
					<h1>Add & Edit Parent Emails</h1>
				</header>

				<p className="instructionsText">
					Add parent emails so that they can sign off on their students' reading logs 
					every week. We don't share email addresses and we only email parents to 
					request reading log approval and share their child's reading progress.
				</p>
				<form onSubmit={ this.submitParentEmails }>
					<ErrorDisplay ref="errors" />
					<table className="table">
						<tbody>
							<tr>
								<th>Class</th>
								<th className="studentName">Student</th>
								<th>Parent Email</th>
							</tr>

							{ studentRows }
						</tbody>
					</table>
					<LoadingButton className="btn buttonSuccess center-block"
						text="Save Emails"
						disabled={ buttonDisabled }
						loading={ this.state.loading }
						onClick={ this.submitParentEmails } />
					{ overallError }
				</form>	
			</div>
		);
	}
}

var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))){2,6}$/i;

StudentParentsPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	students: PropTypes.array.isRequired,
	parents: PropTypes.array.isRequired,
	studentLists: PropTypes.array.isRequired,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	createParents: PropTypes.func.isRequired,
	updateParents: PropTypes.func.isRequired
});


module.exports = StudentParentsPage; 


// WEBPACK FOOTER //
// ./modules/components/users/parents/StudentParentsPage.js